import * as React from "react"
import {Divider, Popover, useTheme} from "@mui/material";
import {bgBlur} from "@ui-seeker/utils";

import {AppLink} from "../index";
import AppPopoverNavItem from "./NavItem";
import { dsColorNew } from "@palette";
import { alpha } from "@mui/material/styles"



export default function AppPopoverNav({ isOpen, anchorEl, routes, handleMouseEnter, handleMouseLeave, handleClose, sx={} }) {
    const theme = useTheme()

    const config = {
        open: isOpen,
        onClose: handleClose,
        anchorEl: anchorEl,
        anchorOrigin: { vertical: 'center', horizontal: 'right' },
        transformOrigin: { vertical: 'center', horizontal: 'left' },
        PaperProps: {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave
        },
        sx: {
            pointerEvents: 'none',
            '& .MuiPopover-paper': {
                width: 'auto',
                pointerEvents: 'auto',
                padding: theme.spacing(0.75),
                marginTop: theme.spacing(0.5),
                boxShadow: `0 4px 24px ${alpha(dsColorNew.black, 0.10)}`,
                borderRadius: '12px',
                border: `1px solid ${dsColorNew.grayBorder}`,
                backgroundColor: dsColorNew.white,
            },
            ...sx
        }
    }

    return <Popover  {...config}>
        { routes.filter(r => !r.noMenu).map( ({ path, title, index, children, badge, ...config }, idx) => {
            if (index) return null

            if (path === 'divider')
                return <Divider key={idx} />

            return <AppLink key={idx} to={path} {...config} onClick={handleClose}>
                <AppPopoverNavItem path={path} title={title} badge={badge} />
            </AppLink>
        }) }
    </Popover>
}